import { render, staticRenderFns } from "./SidebarListReportComponent.vue?vue&type=template&id=6c5456aa&scoped=true&"
import script from "./SidebarListReportComponent.vue?vue&type=script&lang=js&"
export * from "./SidebarListReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarListReportComponent.vue?vue&type=style&index=0&id=6c5456aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5456aa",
  null
  
)

export default component.exports